
import LazyHydrate from 'vue-lazy-hydration'

export default {
    name: 'IndexPage',
    components: {
        LazyHydrate,
    },
}
